export default class Faq {
    static init(): void {
        const triggers: NodeListOf<HTMLElement> = document.querySelectorAll('.faq-item-trigger');

        if (triggers.length > 0) {
            triggers.forEach((trigger) => {
                trigger.addEventListener('click', () => {
                    const item: HTMLElement | null = trigger.closest('.faq-item');

                    if (item) {
                        item.classList.toggle('is-active');
                    }
                });
            });
        }
    }
}
